"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDistributorCustomFilters = void 0;
const routes_1 = require("../../routes");
const updateDistributorCustomFilters = (client) => async (distributorId, payload) => {
    const url = routes_1.ENDPOINTS.UPDATE_PARTNER_CUSTOM_CONFIG.applyParams(distributorId, 'filters');
    const { data } = await client.put(url, payload);
    return data;
};
exports.updateDistributorCustomFilters = updateDistributorCustomFilters;
